import { render } from "./Clientes.vue?vue&type=template&id=78059e60&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"

import "./Clientes.vue?vue&type=style&index=0&id=78059e60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78059e60"]])

export default __exports__